<div class="rag-cleanup-summary-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="rag-cleanup-summary-dialog-header">
    <div class="title">
      Exclude From RAG
      <div class="description">
        Items were excluded from RAG to prevent future similar issues.<br />
        Visit the Prevention Page to review other files that have been excluded.
      </div>
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="rag-cleanup-summary-dialog-body">
    <app-prime-table
      #table
      class="table-component"
      queryParamProperty="finding"
      [data$]="filesCurrentPage$"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      (rowSelected)="rowSelected($event)"
      (rowUnselected)="rowUnselected()"
      [withActions]="false"
      [pageInfo]="pageInfo$.value"
      [sortedColumn$]="sortedColumn$"
      tableNotFoundText="No files found"
      (checkedRowsUpdate)="onCheckboxClick($event)"
      (multiCheckOnClick)="multiSelectedActionClick($event)"
      [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
      [withCheckboxSelection]="false"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
    />
  </div>
  <br />
  <div class="rag-cleanup-summary-dialog-footer">
    <div class="rag-cleanup-summary-dialog-buttons-container">
      <button class="rag-cleanup-summary-dialog-button" (click)="onClose()">DONE</button>
    </div>
  </div>
</div>
